/* global window */

class Analytics {
  static DASHBOARD_SIGNED_IN = 'Dashboard Signed In';
  static DASHBOARD_CLOSED = 'Dashboard Closed';
  static DASHBOARD_RESUMED = 'Dashboard Resumed';

  static USER_SIGNED_OUT = 'User Signed Out';
  static LOGIN_SUCCESSFUL_TRACKER = 'User Login Tracker';

  //TODO
  // static LOGIN_NUMBER_SUBMITTED = 'Login Number Submitted';
  // static LOGIN_CODE_ENTERED = 'Login Code Entered';
  // static TEAM_SETUP_FAILED = "Team Setup Failed";
  // static TEAM_SETUP_COMPLETED = "Team Setup Completed";
  // static TEAM_CREATION_FAILED = "Team Creation Failed";
  // static TEAM_CREATION_COMPLETED = "Team Creation Completed";
  // static TEAM_INVITE_SENT_WEB_ONBOARDING_FIRST = "Team Invite Sent After Web Onboarding Then App Installed";
  // static TEAM_INVITE_FAILED_WEB_ONBOARDING_FIRST = "Team Invite Failed After Web Onboarding Then App Installed";
  // static TEAM_INVITE_SENT = "Team Invite Sent";
  // static TEAM_MEMBER_REMOVED = "Team Member Removed";
  // static ADD_CONTACT_ERROR = "Add Contact Error";
  // static ADD_CONTACT_COMPLETED = "Add Contact Completed";
  // static PROFILE_UPDATED = "Profile Updated";

  static ROOM_CREATED = 'Room Created';
  static ROOM_MEMBERS_ADDED = 'Room Members Added';
  static ROOM_MEMBERS_REMOVED = 'Room Members Removed';
  static MESSAGE_SENT = 'Message Sent';
  static IMAGE_UPLOADED = 'Image Uploaded';
  static JOB_IMAGE_UPLOADED = 'Job Image Uploaded';
  static EVENT_CREATED_DASHBOARD = 'Event Created On Dashboard';

  static TASK_COMPLETED = 'Task Completed';
  static TASK_CREATED = 'Task Created';
  static BULK_TASKS_CREATED = 'Bulk Tasks Created';
  static MATERIALS_ADDED = 'Materials Added';

  static appInfo = {};

  static track = (event, properties) => {
    const userId = Analytics.getUserId()
    const teamId = Analytics.getTeamId()
    const props = Object.assign(Analytics.getCommonProperties(userId, teamId), properties)
    if (!userId) {
      return;
    }
    if (window.analytics){
      //console.log(`Analytics dispatch event ${event}, with props `, props)
      window.analytics.track(event, props);
    }
  }

  static trackScreenView = (currentScreen, properties) => {
    const userId = Analytics.getUserId()
    const teamId = Analytics.getTeamId()
    if (!userId) {
      return;
    }
    if (window.analytics){
      window.analytics.screen({
        userId: userId,
        name: currentScreen,
        properties: Object.assign(Analytics.getCommonProperties(userId, teamId), properties)
      });
    }
  }

  static getUserId = () => {
    return Analytics.appInfo.userId || Analytics.appInfo.fullPhoneNumber
  }

  static getTeamId = () => {
    return Analytics.appInfo.teamId
  }

  static getCommonProperties = (userId, teamId) => {
    const commonProps = {
      user_id: userId,
      platform: Analytics.appInfo.platform,
      version_code: Analytics.appInfo.versionCode
    }
    if (teamId){
      commonProps.team_id = teamId
    }
    return commonProps
  }
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/infra/analytics/Analytics.js